var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndicators(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 70,
    width: 20,
    height: 30,
    fill: "rgb(15, 31, 58)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 50,
    width: 20,
    height: 50,
    fill: "rgb(15, 31, 58)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 30,
    width: 20,
    height: 70,
    fill: "rgb(15, 31, 58)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicators);
export default __webpack_public_path__ + "static/media/indicators.8bd6b1d7c657c94d228f15b3a9526cb8.svg";
export { ForwardRef as ReactComponent };